import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGameFeedController} from '../../../../shared/scripts/ui_game/ui_game_feed/UIGameFeedController'
import {UIMGameFeedView} from './UIMGameFeedView'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {SectionBgAdaptiveView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgViewAdaptive'
import {ChatData} from '@colonist/shared-types'
import {IndexedGameLogData} from '@colonist/game-state-types'
import {TimeoutId} from '@colonist/types'

enum UIVisibleFeed {
    None,
    Chat,
    Logs

}
export class UIMGameFeedController extends UIGameFeedController {
    private activeFeed: UIVisibleFeed = UIVisibleFeed.None
    private resetScrollTimeout: TimeoutId | undefined

    constructor(uiGameManager: UIGameManager) {
        super(uiGameManager)

        this.removeViews()
        this.view = new UIMGameFeedView(uiGameManager)
        this.view.gameChat.buttonElement.addEventListener('touchend', (e: TouchEvent) => {
            e.preventDefault()
            this.sendMessageToServer()
            this.view.gameChat.container.scrollTop = this.view.gameChat.container.scrollHeight
        })

        this.bindContainers()
        this.onScrollCheck()
        this.bindOnKeyDown()
        this.onReconnect()
    }

    private onScrollCheck() {
        const onScrollCallback = (element: HTMLDivElement) => {
            if(element === null) return
            const bottomScrollThreshold = 1
            const isBottom = Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight) <= bottomScrollThreshold
            if(!isBottom) return
            element.parentElement?.classList.remove('new_message')
            this.preventLogScrollUpdate = false
            this.preventChatScrollUpdate = false
            clearTimeout(this.resetScrollTimeout)
        }

        this.view.gameChat.container.addEventListener('scroll', () => onScrollCallback(this.view.gameChat.container))
        this.view.gameLog.container.addEventListener('scroll', () => onScrollCallback(this.view.gameLog.container))
    }

    private bindContainers() {
        const preventScrollCallback = () => {
            this.preventChatScrollUpdate = true
            this.preventLogScrollUpdate = true
            const waitTimeBeforeAutoScrollResumes = 10000
            clearTimeout(this.resetScrollTimeout)
            this.resetScrollTimeout = setTimeout(() => {
                this.preventLogScrollUpdate = false
                this.preventChatScrollUpdate = false
            }, waitTimeBeforeAutoScrollResumes)
        }
        this.view.gameLog.container.addEventListener('touchstart', preventScrollCallback)
        this.view.gameChat.container.addEventListener('touchstart', preventScrollCallback)
    }

    writeToChat(chatData: ChatData) {
        super.writeToChat(chatData)

        if(this.preventChatScrollUpdate == false) return
        this.view.gameChat.container.parentElement?.classList.add('new_message')
    }

    writeToLog(indexedGameLogData: IndexedGameLogData): void {
        super.writeToLog(indexedGameLogData)

        if(this.preventLogScrollUpdate == false) return
        this.view.gameLog.container.parentElement?.classList.add('new_message')
    }

    // eslint-disable-next-line class-methods-use-this
    private removeViews() {
        const elements = document.querySelectorAll('.game-chat-block')
        elements.forEach((e: HTMLDivElement, i: number) => {
            if(e.classList.contains('open')) this.activeFeed = i == 0 ? UIVisibleFeed.Logs : UIVisibleFeed.Chat
            e.remove()
        })
    }

    private bindOnKeyDown() {
        this.view.gameChat.inputElement.onkeydown = (e) => {
            if(e.key != 'Enter') return
            e.preventDefault()
            this.sendMessageToServer()
            this.view.gameChat.container.scrollTop = this.view.gameChat.container.scrollHeight
        }
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        super.onEvent(data, eventType)

        switch(eventType) {
            case UIGameEventEnums.ToggleChatFeed: this.toggleChat(data); break
            case UIGameEventEnums.ToggleLogFeed: this.toggleLogs(data); break
            case UIGameEventEnums.PopupActive: this.updateBaseline(data); break
            default: break
        }
    }

    private toggleChat(shouldOpen: boolean) {
        const shouldAnimate = this.activeFeed == UIVisibleFeed.None
        this.closeAll()
        if(!shouldOpen) return
        if(shouldAnimate) this.animateDiv(this.view.gameChat.container)
        this.view.gameChat.container.parentElement?.classList.add('open')
        this.activeFeed = UIVisibleFeed.Chat
    }

    private toggleLogs(shouldOpen: boolean) {
        const shouldAnimate = this.activeFeed == UIVisibleFeed.None
        this.closeAll()
        if(!shouldOpen) return
        if(shouldAnimate) this.animateDiv(this.view.gameLog.container)
        this.view.gameLog.container.parentElement?.classList.add('open')
        this.activeFeed = UIVisibleFeed.Logs
    }

    // eslint-disable-next-line class-methods-use-this
    private animateDiv(container: HTMLDivElement) {
        container.parentElement?.classList.add('animate')
        setTimeout(() => {
            container.parentElement?.classList.remove('animate')
        }, 200)
    }

    closeAll() {
        this.view.gameLog.container.parentElement?.classList.remove('open')
        this.view.gameChat.container.parentElement?.classList.remove('open')
        document.body.scrollTop = 0
        this.activeFeed = UIVisibleFeed.None
    }

    private updateBaseline(popup: SectionBgAdaptiveView | undefined) {
        if(popup === undefined) {
            const heightOfMyPlayerView = this.uiGameManager.canvasController.bottomViewHeight
            this.view.gameChat.setPositionBottom(heightOfMyPlayerView)
            this.view.gameLog.setPositionBottom(heightOfMyPlayerView)
            return
        }
        if(popup.height == 0) return
        this.view.gameChat.setPositionBottom(this.uiGameManager.canvasController.appH - popup.y)
        this.view.gameLog.setPositionBottom(this.uiGameManager.canvasController.appH - popup.y)
    }

    private onReconnect() {
        if(this.activeFeed == UIVisibleFeed.None) return
        const isChatOpen = this.activeFeed == UIVisibleFeed.Chat
        this.uiGameManager.eventController.sendEvent(true, isChatOpen ? UIGameEventEnums.ToggleChatFeed : UIGameEventEnums.ToggleLogFeed)
    }
}
